import gql from "graphql-tag";

const AssessmentProps = gql`
    fragment AssessmentProps on Assessment {
        id
        name
        created_at
        icon
        scoreGuide {
            min
            max
            desc
            label
        }
        additional
    }
`;
/** New Assessment type */
const NEW_TYPE = gql`
    mutation NewAssessmentType($site: ID!, $name: String!, $icon: String!) {
        NewAssessment(name: $name, site: $site, icon: $icon) {
            message
            doc {
                ...AssessmentProps
            }
        }
    }
    ${AssessmentProps}
`;

/**
 *  Get Assessment type list
 */
const GET_TYPES = gql`
    query get($site: ID!) {
        GetAssessments(site: $site) {
            message
            docs {
                ...AssessmentProps
            }
        }
        GetAssessmentCategories(site: $site) {
            message
            docs {
                id
                name
                created_at
            }
        }
    }
    ${AssessmentProps}
`;

const GET_LIST = gql`
    query GetAssessmentsList($site: ID!) {
        GetAssessments(site: $site) {
            message
            docs {
                id
                name
                icon
            }
        }
    }
`;

const UPDATE_TYPE = gql`
    mutation UpdateAssessment($id: ID!, $name: String!) {
        UpdateAssessment(id: $id, name: $name) {
            message
            doc {
                ...AssessmentProps
            }
        }
    }
    ${AssessmentProps}
`;
// New Assessment category
const NEW_CATEGORY = gql`
    mutation NewAssessmentCategory($site: ID!, $name: String!) {
        NewAssessmentCategory(name: $name, site: $site) {
            message
            doc {
                id
                name
                created_at
            }
        }
    }
`;

// Update Assessment category
const UPDATE_CATEGORY = gql`
    mutation UpdateCategory($id: ID!, $name: String!) {
        UpdateAssessmentCategory(id: $id, name: $name) {
            message
            doc {
                id
                name
                created_at
            }
        }
    }
`;

const GET_QUESTIONS_CATEGORY = gql`
    query FetchData($site: ID!) {
        GetAssessments(site: $site) {
            docs {
                ...AssessmentProps
            }
        }
        GetAssessmentCategories(site: $site) {
            docs {
                id
                name
            }
        }
    }
    ${AssessmentProps}
`;

const GET_QUESTIONS = gql`
    query GetQuestions($assessment: ID!) {
        GetAssessmentQuestions(assessment: $assessment) {
            docs {
                id
                category {
                    id
                    name
                }
                name
                allowMultipleSelection
                options {
                    id
                    name
                    value
                    created_at
                }
            }
        }
    }
`;

/**
 * New Question
 */
const NEW_QUESTION = gql`
    mutation AddQuestion($assessment: ID!, $model: NewAssessmentQuestion!) {
        NewAssessmentQuestion(model: $model, assessment: $assessment) {
            message
            doc {
                id
                category {
                    id
                    name
                }
                name
                allowMultipleSelection
                options {
                    id
                    name
                    value
                    created_at
                }
            }
        }
    }
`;

const UPDATE_QUESTION = gql`
    mutation UpdateQuestion($id: ID!, $name: String!) {
        UpdateAssessmentQuestion(id: $id, newName: $name) {
            message
            doc {
                id
                name
                allowMultipleSelection
                options {
                    id
                    name
                    value
                    created_at
                }
                category {
                    id
                    name
                }
            }
        }
    }
`;

const UPDATE_OPTION = gql`
    mutation UpdateOption($id: ID!, $name: String!, $value: String!) {
        UpdateAssessmentOption(id: $id, name: $name, value: $value) {
            message
            doc {
                id
                name
                value
            }
        }
    }
`;

const NEW_OPTION = gql`
    mutation NewOption($question: ID!, $model: NewAssessmentOption!) {
        NewAssessmentOption(question: $question, model: $model) {
            message
            doc {
                id
                name
                value
            }
        }
    }
`;

const UPDATE_SCORE = gql`
    mutation UpdateScoreGuide($id: ID!, $model: ScoreGuideInput!) {
        AddScoreGuide(id: $id, model: $model) {
            message
            doc {
                ...AssessmentProps
            }
        }
    }
    ${AssessmentProps}
`;
const UPDATE_PROPS = gql`
    mutation AddAdditionalProp($id: ID!, $name: String!) {
        AddAddtionalProp(id: $id, name: $name) {
            message
            doc {
                ...AssessmentProps
            }
        }
    }
    ${AssessmentProps}
`;
export {
    NEW_TYPE,
    GET_TYPES,
    UPDATE_TYPE,
    NEW_CATEGORY,
    UPDATE_CATEGORY,
    GET_QUESTIONS_CATEGORY,
    GET_QUESTIONS,
    NEW_QUESTION,
    UPDATE_QUESTION,
    NEW_OPTION,
    UPDATE_OPTION,
    UPDATE_SCORE,
    UPDATE_PROPS,
    GET_LIST
};
